import React, { useContext } from "react";
import { RequestsContext } from "../../context/requests";
import styled from "styled-components";


const CardWrapper = styled.div`
    display: flex;
    align-items: center;

    li{
        font-size:0.9rem;
        font-family: "Poppins";
        font-weight: 600;
        cursor: pointer;
        list-style: none;
        margin-right: 1.2rem;
    }

`

const PaginationTinyOptions = () => {
    const { selectItems } = useContext(RequestsContext)

    return (

        <CardWrapper>
            <li>{selectItems.length}</li>


        </CardWrapper>


    )
}

export default PaginationTinyOptions